import { Tag, TagLabel, TagLeftIcon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FiCheckCircle, FiHelpCircle, FiXCircle } from "react-icons/fi";

interface Props {
  fulfilled: boolean | null | undefined;
}

export const FulfilmentTag = ({ fulfilled }: Props) => {
  const { t } = useTranslation();
  if (fulfilled === true) {
    return (
      <Tag colorScheme="green" size="md" borderRadius="full">
        <TagLeftIcon as={FiCheckCircle} />
        <TagLabel>{t("Fulfilled")}</TagLabel>
      </Tag>
    );
  }
  if (fulfilled === false) {
    return (
      <Tag colorScheme="red" size="md" borderRadius="full">
        <TagLeftIcon as={FiXCircle} />
        <TagLabel>{t("Not fulfilled")}</TagLabel>
      </Tag>
    );
  }
  return (
    <Tag colorScheme="gray" size="md" borderRadius="full">
      <TagLeftIcon as={FiHelpCircle} />
      <TagLabel>{t("Not answered")}</TagLabel>
    </Tag>
  );
};
